<template lang="pug">
    v-dialog(
        :value="show"
        @input="close"
        max-width="350"
    )
        v-card(class="remove-card")
            slot(name="title")
                v-card-title
                    span.dialog-title {{ title }}
            slot(name="message" v-if="message")
                span.dialog-message {{ message }}
            .dialog-actions
                v-btn(
                    v-for="(button, index) in buttons"
                    @click="button.action"
                    :color="button.color"
                    :key="index"
                    icon flat
                )
                    v-icon {{ button.icon }}
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        message: {
            type: String,
            default: null
        },
        accountId: {
            type: Number,
            default: null
        },
        accountType: {
            type: String,
            default: null
        }
    },
    computed: {
        buttons() {
            return [{
                color: 'red',
                icon: 'clear',
                action: this.close
            }, {
                color: 'success',
                icon: 'check',
                action: this.lock
            }]
        }
    },
    methods: {
        lock() {
            this.$store.dispatch('changeActivity', {
                id: this.accountId,
                accountType: this.accountType
            }).then(res => {
                if (res) this.$emit('close')
            })
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
    .dialog {
        &-title, &-message {
            display: block;
            width: 100%;
            text-align: center;
            user-select: none;
        }

        &-title {
            font-size: 14pt;
            font-weight: 500;
        }

        &-actions {
            display: flex;
            justify-content: flex-end;
        }
    }
</style>
